/* istanbul ignore file */
// Generated automatically by nearley, version 2.20.1
// http://github.com/Hardmath123/nearley
// NOTE: the nearley output is a UMD IIFE. Only the wrapper is hand-edited (here
// and at the end of the file) to export as ESM — Vite does not apply CJS interop
// to first-party src/ files, so the original `module.exports` assignment left
// this module empty. The generated body in between is untouched.
const compiledGrammar = (function () {
  function id(x) {
    return x[0]
  }
  const grammar = {
    Lexer: undefined,
    ParserRules: [
      { name: 'dqstring$ebnf$1', symbols: [] },
      {
        name: 'dqstring$ebnf$1',
        symbols: ['dqstring$ebnf$1', 'dstrchar'],
        postprocess: function arrpush(d) {
          return d[0].concat([d[1]])
        },
      },
      {
        name: 'dqstring',
        symbols: [{ literal: '"' }, 'dqstring$ebnf$1', { literal: '"' }],
        postprocess: function (d) {
          return d[1].join('')
        },
      },
      { name: 'sqstring$ebnf$1', symbols: [] },
      {
        name: 'sqstring$ebnf$1',
        symbols: ['sqstring$ebnf$1', 'sstrchar'],
        postprocess: function arrpush(d) {
          return d[0].concat([d[1]])
        },
      },
      {
        name: 'sqstring',
        symbols: [{ literal: "'" }, 'sqstring$ebnf$1', { literal: "'" }],
        postprocess: function (d) {
          return d[1].join('')
        },
      },
      { name: 'btstring$ebnf$1', symbols: [] },
      {
        name: 'btstring$ebnf$1',
        symbols: ['btstring$ebnf$1', /[^`]/],
        postprocess: function arrpush(d) {
          return d[0].concat([d[1]])
        },
      },
      {
        name: 'btstring',
        symbols: [{ literal: '`' }, 'btstring$ebnf$1', { literal: '`' }],
        postprocess: function (d) {
          return d[1].join('')
        },
      },
      { name: 'dstrchar', symbols: [/[^\\"\n]/], postprocess: id },
      {
        name: 'dstrchar',
        symbols: [{ literal: '\\' }, 'strescape'],
        postprocess: function (d) {
          return JSON.parse('"' + d.join('') + '"')
        },
      },
      { name: 'sstrchar', symbols: [/[^\\'\n]/], postprocess: id },
      {
        name: 'sstrchar',
        symbols: [{ literal: '\\' }, 'strescape'],
        postprocess: function (d) {
          return JSON.parse('"' + d.join('') + '"')
        },
      },
      {
        name: 'sstrchar$string$1',
        symbols: [{ literal: '\\' }, { literal: "'" }],
        postprocess: function joiner(d) {
          return d.join('')
        },
      },
      {
        name: 'sstrchar',
        symbols: ['sstrchar$string$1'],
        postprocess: function (d) {
          return "'"
        },
      },
      { name: 'strescape', symbols: [/["\\/bfnrt]/], postprocess: id },
      {
        name: 'strescape',
        symbols: [{ literal: 'u' }, /[a-fA-F0-9]/, /[a-fA-F0-9]/, /[a-fA-F0-9]/, /[a-fA-F0-9]/],
        postprocess: function (d) {
          return d.join('')
        },
      },
      { name: '_$ebnf$1', symbols: [] },
      {
        name: '_$ebnf$1',
        symbols: ['_$ebnf$1', 'wschar'],
        postprocess: function arrpush(d) {
          return d[0].concat([d[1]])
        },
      },
      {
        name: '_',
        symbols: ['_$ebnf$1'],
        postprocess: function (d) {
          return null
        },
      },
      { name: '__$ebnf$1', symbols: ['wschar'] },
      {
        name: '__$ebnf$1',
        symbols: ['__$ebnf$1', 'wschar'],
        postprocess: function arrpush(d) {
          return d[0].concat([d[1]])
        },
      },
      {
        name: '__',
        symbols: ['__$ebnf$1'],
        postprocess: function (d) {
          return null
        },
      },
      { name: 'wschar', symbols: [/[ \t\n\v\f]/], postprocess: id },
      { name: 'unsigned_int$ebnf$1', symbols: [/[0-9]/] },
      {
        name: 'unsigned_int$ebnf$1',
        symbols: ['unsigned_int$ebnf$1', /[0-9]/],
        postprocess: function arrpush(d) {
          return d[0].concat([d[1]])
        },
      },
      {
        name: 'unsigned_int',
        symbols: ['unsigned_int$ebnf$1'],
        postprocess: function (d) {
          return parseInt(d[0].join(''))
        },
      },
      { name: 'int$ebnf$1$subexpression$1', symbols: [{ literal: '-' }] },
      { name: 'int$ebnf$1$subexpression$1', symbols: [{ literal: '+' }] },
      { name: 'int$ebnf$1', symbols: ['int$ebnf$1$subexpression$1'], postprocess: id },
      {
        name: 'int$ebnf$1',
        symbols: [],
        postprocess: function (d) {
          return null
        },
      },
      { name: 'int$ebnf$2', symbols: [/[0-9]/] },
      {
        name: 'int$ebnf$2',
        symbols: ['int$ebnf$2', /[0-9]/],
        postprocess: function arrpush(d) {
          return d[0].concat([d[1]])
        },
      },
      {
        name: 'int',
        symbols: ['int$ebnf$1', 'int$ebnf$2'],
        postprocess: function (d) {
          if (d[0]) {
            return parseInt(d[0][0] + d[1].join(''))
          } else {
            return parseInt(d[1].join(''))
          }
        },
      },
      { name: 'unsigned_decimal$ebnf$1', symbols: [/[0-9]/] },
      {
        name: 'unsigned_decimal$ebnf$1',
        symbols: ['unsigned_decimal$ebnf$1', /[0-9]/],
        postprocess: function arrpush(d) {
          return d[0].concat([d[1]])
        },
      },
      { name: 'unsigned_decimal$ebnf$2$subexpression$1$ebnf$1', symbols: [/[0-9]/] },
      {
        name: 'unsigned_decimal$ebnf$2$subexpression$1$ebnf$1',
        symbols: ['unsigned_decimal$ebnf$2$subexpression$1$ebnf$1', /[0-9]/],
        postprocess: function arrpush(d) {
          return d[0].concat([d[1]])
        },
      },
      {
        name: 'unsigned_decimal$ebnf$2$subexpression$1',
        symbols: [{ literal: '.' }, 'unsigned_decimal$ebnf$2$subexpression$1$ebnf$1'],
      },
      {
        name: 'unsigned_decimal$ebnf$2',
        symbols: ['unsigned_decimal$ebnf$2$subexpression$1'],
        postprocess: id,
      },
      {
        name: 'unsigned_decimal$ebnf$2',
        symbols: [],
        postprocess: function (d) {
          return null
        },
      },
      {
        name: 'unsigned_decimal',
        symbols: ['unsigned_decimal$ebnf$1', 'unsigned_decimal$ebnf$2'],
        postprocess: function (d) {
          return parseFloat(d[0].join('') + (d[1] ? '.' + d[1][1].join('') : ''))
        },
      },
      { name: 'decimal$ebnf$1', symbols: [{ literal: '-' }], postprocess: id },
      {
        name: 'decimal$ebnf$1',
        symbols: [],
        postprocess: function (d) {
          return null
        },
      },
      { name: 'decimal$ebnf$2', symbols: [/[0-9]/] },
      {
        name: 'decimal$ebnf$2',
        symbols: ['decimal$ebnf$2', /[0-9]/],
        postprocess: function arrpush(d) {
          return d[0].concat([d[1]])
        },
      },
      { name: 'decimal$ebnf$3$subexpression$1$ebnf$1', symbols: [/[0-9]/] },
      {
        name: 'decimal$ebnf$3$subexpression$1$ebnf$1',
        symbols: ['decimal$ebnf$3$subexpression$1$ebnf$1', /[0-9]/],
        postprocess: function arrpush(d) {
          return d[0].concat([d[1]])
        },
      },
      {
        name: 'decimal$ebnf$3$subexpression$1',
        symbols: [{ literal: '.' }, 'decimal$ebnf$3$subexpression$1$ebnf$1'],
      },
      { name: 'decimal$ebnf$3', symbols: ['decimal$ebnf$3$subexpression$1'], postprocess: id },
      {
        name: 'decimal$ebnf$3',
        symbols: [],
        postprocess: function (d) {
          return null
        },
      },
      {
        name: 'decimal',
        symbols: ['decimal$ebnf$1', 'decimal$ebnf$2', 'decimal$ebnf$3'],
        postprocess: function (d) {
          return parseFloat((d[0] || '') + d[1].join('') + (d[2] ? '.' + d[2][1].join('') : ''))
        },
      },
      {
        name: 'percentage',
        symbols: ['decimal', { literal: '%' }],
        postprocess: function (d) {
          return d[0] / 100
        },
      },
      { name: 'jsonfloat$ebnf$1', symbols: [{ literal: '-' }], postprocess: id },
      {
        name: 'jsonfloat$ebnf$1',
        symbols: [],
        postprocess: function (d) {
          return null
        },
      },
      { name: 'jsonfloat$ebnf$2', symbols: [/[0-9]/] },
      {
        name: 'jsonfloat$ebnf$2',
        symbols: ['jsonfloat$ebnf$2', /[0-9]/],
        postprocess: function arrpush(d) {
          return d[0].concat([d[1]])
        },
      },
      { name: 'jsonfloat$ebnf$3$subexpression$1$ebnf$1', symbols: [/[0-9]/] },
      {
        name: 'jsonfloat$ebnf$3$subexpression$1$ebnf$1',
        symbols: ['jsonfloat$ebnf$3$subexpression$1$ebnf$1', /[0-9]/],
        postprocess: function arrpush(d) {
          return d[0].concat([d[1]])
        },
      },
      {
        name: 'jsonfloat$ebnf$3$subexpression$1',
        symbols: [{ literal: '.' }, 'jsonfloat$ebnf$3$subexpression$1$ebnf$1'],
      },
      { name: 'jsonfloat$ebnf$3', symbols: ['jsonfloat$ebnf$3$subexpression$1'], postprocess: id },
      {
        name: 'jsonfloat$ebnf$3',
        symbols: [],
        postprocess: function (d) {
          return null
        },
      },
      { name: 'jsonfloat$ebnf$4$subexpression$1$ebnf$1', symbols: [/[+-]/], postprocess: id },
      {
        name: 'jsonfloat$ebnf$4$subexpression$1$ebnf$1',
        symbols: [],
        postprocess: function (d) {
          return null
        },
      },
      { name: 'jsonfloat$ebnf$4$subexpression$1$ebnf$2', symbols: [/[0-9]/] },
      {
        name: 'jsonfloat$ebnf$4$subexpression$1$ebnf$2',
        symbols: ['jsonfloat$ebnf$4$subexpression$1$ebnf$2', /[0-9]/],
        postprocess: function arrpush(d) {
          return d[0].concat([d[1]])
        },
      },
      {
        name: 'jsonfloat$ebnf$4$subexpression$1',
        symbols: [
          /[eE]/,
          'jsonfloat$ebnf$4$subexpression$1$ebnf$1',
          'jsonfloat$ebnf$4$subexpression$1$ebnf$2',
        ],
      },
      { name: 'jsonfloat$ebnf$4', symbols: ['jsonfloat$ebnf$4$subexpression$1'], postprocess: id },
      {
        name: 'jsonfloat$ebnf$4',
        symbols: [],
        postprocess: function (d) {
          return null
        },
      },
      {
        name: 'jsonfloat',
        symbols: ['jsonfloat$ebnf$1', 'jsonfloat$ebnf$2', 'jsonfloat$ebnf$3', 'jsonfloat$ebnf$4'],
        postprocess: function (d) {
          return parseFloat(
            (d[0] || '') +
              d[1].join('') +
              (d[2] ? '.' + d[2][1].join('') : '') +
              (d[3] ? 'e' + (d[3][1] || '+') + d[3][2].join('') : ''),
          )
        },
      },
      { name: 'Equals$subexpression$1', symbols: ['contextDataPath'] },
      { name: 'Equals$subexpression$1', symbols: ['storeDataPath'] },
      {
        name: 'Equals',
        symbols: ['Equals$subexpression$1', '__', { literal: '=' }, '__', 'var'],
        postprocess: function (d) {
          return { name: d[2], left: d[0][0], right: d[4] }
        },
      },
      { name: 'var', symbols: ['unsigned_int'] },
      {
        name: 'var',
        symbols: ['dqstring'],
        postprocess: function (d) {
          return d[0]
        },
      },
      { name: 'prop$ebnf$1', symbols: [/[a-zA-Z_-]/] },
      {
        name: 'prop$ebnf$1',
        symbols: ['prop$ebnf$1', /[a-zA-Z_-]/],
        postprocess: function arrpush(d) {
          return d[0].concat([d[1]])
        },
      },
      { name: 'prop', symbols: ['prop$ebnf$1'], postprocess: (d) => d[0].join('') },
      {
        name: 'contextDataPath$string$1',
        symbols: [
          { literal: 'c' },
          { literal: 'o' },
          { literal: 'n' },
          { literal: 't' },
          { literal: 'e' },
          { literal: 'x' },
          { literal: 't' },
        ],
        postprocess: function joiner(d) {
          return d.join('')
        },
      },
      {
        name: 'contextDataPath',
        symbols: [
          'contextDataPath$string$1',
          { literal: '.' },
          'contextDataEntity',
          { literal: '.' },
          'prop',
        ],
        postprocess: function (d) {
          return { name: 'contextLookup', path: `${d[0]}.${d[2]}.${d[4]}` }
        },
      },
      {
        name: 'contextDataEntity$string$1',
        symbols: [{ literal: 'h' }, { literal: 'u' }, { literal: 'b' }],
        postprocess: function joiner(d) {
          return d.join('')
        },
      },
      { name: 'contextDataEntity', symbols: ['contextDataEntity$string$1'] },
      {
        name: 'contextDataEntity$string$2',
        symbols: [{ literal: 'u' }, { literal: 's' }, { literal: 'e' }, { literal: 'r' }],
        postprocess: function joiner(d) {
          return d.join('')
        },
      },
      { name: 'contextDataEntity', symbols: ['contextDataEntity$string$2'] },
      {
        name: 'storeDataPath$string$1',
        symbols: [
          { literal: 'i' },
          { literal: 'r' },
          { literal: 'o' },
          { literal: 'n' },
          { literal: 's' },
          { literal: 'i' },
          { literal: 'g' },
          { literal: 'h' },
          { literal: 't' },
        ],
        postprocess: function joiner(d) {
          return d.join('')
        },
      },
      {
        name: 'storeDataPath',
        symbols: [
          'storeDataPath$string$1',
          { literal: '.' },
          'storeDataEntity',
          { literal: '.' },
          'var',
          { literal: '.' },
          'prop',
        ],
        postprocess: function (d) {
          return {
            name: 'storeLookup',
            path: `${d[0]}.${d[2]}`,
            args: { id: d[4], property: d[6] },
          }
        },
      },
      {
        name: 'storeDataEntity$string$1',
        symbols: [
          { literal: 'l' },
          { literal: 'o' },
          { literal: 'c' },
          { literal: 'a' },
          { literal: 't' },
          { literal: 'i' },
          { literal: 'o' },
          { literal: 'n' },
          { literal: 's' },
        ],
        postprocess: function joiner(d) {
          return d.join('')
        },
      },
      { name: 'storeDataEntity', symbols: ['storeDataEntity$string$1'] },
      {
        name: 'storeDataEntity$string$2',
        symbols: [
          { literal: 'u' },
          { literal: 's' },
          { literal: 'e' },
          { literal: 'r' },
          { literal: 's' },
        ],
        postprocess: function joiner(d) {
          return d.join('')
        },
      },
      { name: 'storeDataEntity', symbols: ['storeDataEntity$string$2'] },
      {
        name: 'storeDataEntity$string$3',
        symbols: [
          { literal: 'b' },
          { literal: 'u' },
          { literal: 's' },
          { literal: 'i' },
          { literal: 'n' },
          { literal: 'e' },
          { literal: 's' },
          { literal: 's' },
          { literal: 'U' },
          { literal: 'n' },
          { literal: 'i' },
          { literal: 't' },
          { literal: 's' },
        ],
        postprocess: function joiner(d) {
          return d.join('')
        },
      },
      { name: 'storeDataEntity', symbols: ['storeDataEntity$string$3'] },
    ],
    ParserStart: 'Equals',
  }
  return grammar
})()

export default compiledGrammar
